import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import "./App.css";
import LoginPage from "./components/LoginPage";
import AdminLayout from "./components/AdminLayout";
import BillingPage from "./components/BillingPage";

import { Toaster } from "sonner";
import CreateIDPage from "./components/CreateIDPage";
import Wholesale from "./components/Wholesale";
import WorkerDashboardWrapper from "./components/WorkerDashboardWrapper";
import Retail from "./components/Retail";
import Retaildetails from "./components/Retaildetails";
import WorkerLayout from "./components/WorkerLayout";
import WorkerDashboard from "./components/WorkerDashboard";
import WorkerProductStats from "./components/WorkerProductStats";
import WorkerDetails from "./components/WorkerDetails";
import WorkerQuantity from "./components/WorkerQuantity";
import AdminDashboard from "./components/AdminDashboard";
import AdminWorkerDetails from "./components/AdminWorkerDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import CustomerDetails from "./components/CustomerDetails";
import WorkersTable from "./components/WorkersTable";
// import BarcodeCartDemo from "./components/BarcodeCartDemo";
import { CreditDetails } from "./components/CreditDetails";
import WorkerBilling from "./components/WorkerBilling";
import WorkerRetailDetails from "./components/WorkerRetailDetails";
import { WorkerCreditDetails } from "./components/WorkerCreditDetails";
import Dashboard from "./components/Dashboard";
import ScrollToTop from "./components/ScrollToTop";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import WorkerCustomerDetails from "./components/WorkerCustomerDetails";
// import { WorkersCreditDetails } from "./components/WorkersCreditDetails";
import AllWorkersBills from "./components/AllWorkersBills";
import CreateCompanyWorker from "./components/CreateCompanyWorker";
import ProductDetails from "./components/ProductDetails";
import WorkerBills from "./components/WorkerWorkerBills";
import StaffWorkerDetails from "./components/StaffWorkerDetails";
import StockCredit from "./components/StockCredit";
import WorkerStockReturn from "./components/WorkerStockReturn";
import RetailDetails from "./components/Retaildetails";

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/a" element={<BillingPage />} />

        {/* Admin Routes with Nested Layout */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard1" element={<Dashboard />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="create-id" element={<CreateIDPage />} />
          <Route path="createcompanyworker" element={<CreateCompanyWorker />} />
          <Route path="wholesale" element={<Wholesale />} />
          <Route path="retail" element={<Retail />} />
          <Route path="retaildetails" element={<Retaildetails />} />
          <Route path="worker-bills" element={<WorkerDetails />} />
          <Route
            path="worker-details/:id/:name"
            element={<AdminWorkerDetails />}
          />
          <Route path="customer-details" element={<CustomerDetails />} />
          <Route path="worker-detail" element={<WorkersTable />} />
          <Route path="credit" element={<CreditDetails />} />
          {/* <Route path="bar" element={<BarcodeCartDemo />} /> */}
          <Route path="all-workers-bills" element={<AllWorkersBills />} />

          <Route
            path="workers-credit-details"
            element={<WorkerCreditDetails />}
          />
          <Route path="workers-bills" element={<AdminDashboard />} />
          <Route path="product-details" element={<ProductDetails />} />
          <Route path="stock-credit" element={<StockCredit />} />
          <Route path="workerstockreturn" element={<WorkerStockReturn />} />
        </Route>

        <Route
          path="/worker"
          element={
            <ProtectedRoute role="worker">
              <WorkerLayout />
            </ProtectedRoute>
          }
        >
          {/* <Route path="stats/:id" element={<WorkerDashboard />} /> */}
          {/* <Route path="dashboard/:id" element={<WorkerDashboardWrapper />} /> */}
          <Route path="/worker/quantity/:id" element={<WorkerQuantity />} />
          <Route path="billing/:id" element={<Retail />} />
          <Route path="retail/:id" element={<RetailDetails />} />
          <Route path="credit/:id" element={<CreditDetails />} />
          <Route
            path="worker-customer-details"
            element={<WorkerCustomerDetails />}
          />
          <Route path="product-details" element={<ProductDetails />} />
          <Route path="wholesale/:id" element={<BillingPage />} />
          <Route path="workerbills/:id" element={<WorkerBills />} />
          <Route
            path="worker-details/:id/:name"
            element={<StaffWorkerDetails />}
          />
          <Route path="wholesale" element={<Wholesale />} />

          <Route path="all-workers-bills/:id" element={<AllWorkersBills />} />
          <Route
            path="workers-credit-details/:id"
            element={<WorkerCreditDetails />}
          />
          <Route path="create-id/:id" element={<CreateIDPage />} />
          <Route path="workerstockreturn/:id" element={<WorkerStockReturn />} />
          <Route path="stock-credit" element={<StockCredit />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
